import { FunctionComponent } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { oneLine } from 'common-tags';

import { CaretDown, ChevronDown } from '@/icons';

import { TypeAccordionProps } from './types';

export const Accordion: FunctionComponent<TypeAccordionProps> = ({
  className,
  title,
  children,
  variant,
  defaultOpen = false,
  font = 'large',
}: TypeAccordionProps) => {
  const Icon = variant !== 'link' ? ChevronDown : CaretDown;

  return (
    <Disclosure
      as="div"
      className={oneLine`
        text-body
        ${font === 'small' ? 'text-body--s' : ''}
        ${font === 'medium' ? 'text-body--m' : ''}
        ${font === 'large' ? 'text-body--l' : ''}
        ${className}
      `}
      defaultOpen={defaultOpen}
    >
      {({ open }) => (
        <>
          <DisclosureButton
            className={oneLine`
              flex text-left w-full py-6 items-center font-semibold
              ${variant === 'link'
                ? 'text-primary-500 tracking-widest uppercase'
                : 'justify-between'
              }
              ${variant === 'h2' ? 'text-xl' : 'justify-between'}
            `}
          >
            {variant === 'h2' ? <h2>{title}</h2> : <>{title}</>}
            <Icon
              className={`text-primary-500 ${open ? 'rotate-180' : ''}`}
              width={32}
              height={28}
            />
          </DisclosureButton>
          <DisclosurePanel
            transition
            unmount={false}
            className="py-6 transition duration-20 ease-out data-[closed]:opacity-0 data-[closed]:scale-95"
          >
            {children}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
};

Accordion.displayName = 'Accordion';
